import React, {Component} from 'react';
import moment from 'moment';
import {cloneDeep} from 'lodash';
import Util from '../../../forecast-app/shared/util/util';
import * as tracking from '../../../tracking';
import ProjectTeamLineItem from '../../../components/project-team/project_team_line_item';
import {ELEMENT_TYPE, PROJECT_STATUS} from '../../../constants';
import {Button, MSTeamsIcon} from 'web-components';
import GenericEmptyState from '../../../containers/project/empty_states/generic_empty_state';
import CreateProjectPersonMutation from '../../../mutations/create_project_person_mutation';
import ExportTeamToTeamsMutation from '../../../mutations/ExportTeamToTeamsMutation';
import LinkTeamToTeamsMutation from '../../../mutations/LinkTeamToTeamsMutation';
import UnlinkTeamsMutation from '../../../mutations/UnlinkTeamsMutation';
import {createToast} from '../../../forecast-app/shared/components/toasts/another-toast/toaster';
import {showModal, MODAL_TYPE} from '../../../forecast-app/shared/components/modals/generic_modal_conductor';
import PropTypes from 'prop-types';
import HeaderBar, {buildThirdLevelNavHeader} from '../../../forecast-app/shared/components/headers/header-bar/header_bar';
import {hasFeatureFlag, usingTimeApproval} from '../../../forecast-app/shared/util/FeatureUtil';
import InformationIcon from '../../../images/information-icon';
import ForecastTooltip from '../../../forecast-app/shared/components/tooltips/ForecastTooltip';
import {TopHeaderBar, TopHeaderBarWrapper} from '../../../forecast-app/shared/components/headers/top-header-bar/TopHeaderBar';
import {hasPermission, isClientUser} from '../../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../../Permissions';

class ProjectSettingsTeam extends Component {
	constructor(props) {
		super(props);
		this.state = this.getFreshStateObject(this.props);
		this.handleShortcutProjectTeam = this.handleShortcutProjectTeam.bind(this);
		this.setComponentData(props);
	}

	componentDidMount() {
		const name = this.props.viewer.project
			? this.props.viewer.project.name !== null && this.props.viewer.project.name !== ''
				? this.props.viewer.project.name
				: 'P-' + this.props.viewer.project.companyProjectId
			: this.props.viewer.projectGroup.name;
		document.title = 'Team - ' + name + ' - Forecast';
		document.addEventListener('keydown', this.handleShortcutProjectTeam);

		// Segment
		tracking.trackPage('project-team');

		if (this.props.viewer.company.teamsEnabled && this.props.viewer.project) this.getTeams();
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		if (this.props.projectId !== nextProps.projectId) {
			this.setState(this.getFreshStateObject(nextProps));
		}
	}

	UNSAFE_componentWillUpdate(nextProps, nextState) {
		this.setComponentData(nextProps);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleShortcutProjectTeam);
	}

	setComponentData(props) {
		const projectPeopleIds = props.viewer.project ? props.viewer.project.projectPersons.edges.map(p => p.node.person.id) : props.viewer.projectGroup.projects.edges[0].node.projectPersons.edges.map(p => p.node.person.id);

		this.peopleOptions = props.viewer.company.allPersons.edges
			.filter(person => !projectPeopleIds.includes(person.node.id))
			.map(person => ({
				value: person.node.id,
				label: person.node.firstName + ' ' + person.node.lastName,
				isTeam: false,
				profilePictureId: person.node.profilePictureId,
				profilePictureDefaultId: person.node.profilePictureDefaultId,
				nestedOptions: [],
			}))
			.sort((a, b) => {
				if (a.label.toUpperCase() < b.label.toUpperCase()) return -1;
				if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
				return 0;
			});

		this.nonEmptyTeams = props.viewer.company.teams.edges
			.filter(team => team.node.teamPersons.edges.length !== 0 && team.node.teamPersons.edges.filter(tp => tp.node.person.active && !projectPeopleIds.includes(tp.node.person.id)).length !== 0)
			.sort((a, b) => {
				if (a.node.name.toUpperCase() < b.node.name.toUpperCase()) return -1;
				if (a.node.name.toUpperCase() > b.node.name.toUpperCase()) return 1;
				return 0;
			});
		this.teamOptions = this.nonEmptyTeams.map(team => ({value: team.node.id, label: team.node.name, isTeam: true, nestedOptions: []}));
	}

	getFreshStateObject(props) {
		return {
			searchFilterValue: '',
			mainRoleFilterValue: props.viewer.project
				? (JSON.parse(localStorage.getItem('project-team-filter-value-' + props.viewer.project.id + '-mainRole')) || []).filter(val => val !== null)
				: (JSON.parse(localStorage.getItem('project-group-team-filter-value-' + props.viewer.projectGroup.id + '-mainRole')) || []).filter(val => val !== null),
			projectRoleFilterValue: props.viewer.project
				? (JSON.parse(localStorage.getItem('project-team-filter-value-' + props.viewer.project.id + '-projectRole')) || []).filter(val => val !== null)
				: (JSON.parse(localStorage.getItem('project-group-team-filter-value-' + props.viewer.projectGroup.id + '-projectRole')) || []).filter(val => val !== null),
			permissionFilterValue: props.viewer.project
				? (JSON.parse(localStorage.getItem('project-team-filter-value-' + props.viewer.project.id + '-permission')) || []).filter(val => val !== null)
				: (JSON.parse(localStorage.getItem('project-group-team-filter-value-' + props.viewer.projectGroup.id + '-permission')) || []).filter(val => val !== null),
			skillFilterValue: props.viewer.project
				? (JSON.parse(localStorage.getItem('project-team-filter-value-' + props.viewer.project.id + '-skill')) || []).filter(val => val !== null)
				: (JSON.parse(localStorage.getItem('project-group-team-filter-value-' + props.viewer.projectGroup.id + '-skill')) || []).filter(val => val !== null),
			showContactInfo: false,
			addPeopleSearchValue: '',
			msTeamsTeams: [{value: null, label: this.props.intl.formatMessage({id: 'common.loading'})}],
			retry: props.retry,
		};
	}

	handleSearchChange(val) {
		this.setState({searchFilterValue: val});
	}

	handleFilterChange(filterType, value) {
		this.setState({[filterType + 'FilterValue']: value});
		if (this.props.viewer.project) {
			Util.localStorageSetItem('project-team-filter-value-' + this.props.viewer.project.id + '-' + filterType, JSON.stringify(value));
		} else {
			Util.localStorageSetItem('project-group-team-filter-value-' + this.props.viewer.projectGroup.id + '-' + filterType, JSON.stringify(value));
		}
	}

	handleShortcutProjectTeam(e) {
		if (e.altKey && e.shiftKey && e.keyCode === 88) {
			this.clearFilters();
		}
	}

	clearFilters() {
		this.setState({
			mainRoleFilterValue: [],
			projectRoleFilterValue: [],
			permissionFilterValue: [],
			skillFilterValue: [],
			searchFilterValue: '',
		});
		if (this.props.viewer.project) {
			localStorage.removeItem('project-team-filter-value-' + this.props.viewer.project.id + '-mainRole');
			localStorage.removeItem('project-team-filter-value-' + this.props.viewer.project.id + '-projectRole');
			localStorage.removeItem('project-team-filter-value-' + this.props.viewer.project.id + '-permission');
			localStorage.removeItem('project-team-filter-value-' + this.props.viewer.project.id + '-skill');
		} else {
			localStorage.removeItem('project-group-team-filter-value-' + this.props.viewer.projectGroup.id + '-mainRole');
			localStorage.removeItem('project-group-team-filter-value-' + this.props.viewer.projectGroup.id + '-projectRole');
			localStorage.removeItem('project-group-team-filter-value-' + this.props.viewer.projectGroup.id + '-permission');
			localStorage.removeItem('project-group-team-filter-value-' + this.props.viewer.projectGroup.id + '-skill');
		}
	}

	getClearFilterText() {
		const {formatMessage} = this.props.intl;
		const isAnyFilterUsed = this.state.mainRoleFilterValue.length || this.state.projectRoleFilterValue.length || this.state.permissionFilterValue.length || this.state.skillFilterValue.length;
		if (isAnyFilterUsed) {
			if (this.state.searchFilterValue.trim().length) {
				return formatMessage({id: 'common.clear-all'});
			} else {
				return formatMessage({id: 'common.clear-filters'});
			}
		}
		if (this.state.searchFilterValue.trim().length) {
			return formatMessage({id: 'common.clear-search'});
		}
		return '';
	}

	showAddTeamMemberModal() {
		const project = this.props.viewer.project ? this.props.viewer.project : this.props.viewer.projectGroup.projects.edges[0].node;
		let useManualAllocations;
		if (this.props.viewer.project && this.props.viewer.project.useManualAllocations) {
			useManualAllocations = true;
		} else if (this.props.viewer.projectGroup && this.props.viewer.projectGroup.useManualAllocations) {
			useManualAllocations = true;
		}
		showModal({
			viewer: this.props.viewer,
			type: MODAL_TYPE.ADD_TEAM_MEMBER,
			addClientUser: false,
			companyId: this.props.viewer.company.id,
			projectId: project.id,
			project: project,
			projectGroupId: this.props.viewer.project ? null : this.props.viewer.projectGroup.id,
			buttonLocation: 'Project Team',
			useManualAllocations,
		});
	}

	getDates() {
		let startDate = null;
		let endDate = null;
		if (this.props.viewer.project) {
			if (this.props.viewer.project.projectStartYear) {
				startDate = Util.CreateNonUtcMomentDate(this.props.viewer.project.projectStartYear, this.props.viewer.project.projectStartMonth, this.props.viewer.project.projectStartDay);
			}
			if (this.props.viewer.project.projectEndYear) {
				endDate = Util.CreateNonUtcMomentDate(this.props.viewer.project.projectEndYear, this.props.viewer.project.projectEndMonth, this.props.viewer.project.projectEndDay);
			}
		} else if (this.props.viewer.projectGroup) {
			this.props.viewer.projectGroup.projects.edges.forEach(project => {
				const projectStartDate = project.node.projectStartYear ? Util.CreateNonUtcMomentDate(project.node.projectStartYear, project.node.projectStartMonth, project.node.projectStartDay) : null;
				const projectEndDate = project.node.projectEndYear ? Util.CreateNonUtcMomentDate(project.node.projectEndYear, project.node.projectEndMonth, project.node.projectEndDay) : null;
				if ((projectStartDate !== null && startDate === null) || (projectStartDate !== null && startDate !== null && projectStartDate.isBefore(startDate))) {
					startDate = projectStartDate;
				}
				if ((projectEndDate !== null && endDate === null) || (projectEndDate !== null && endDate !== null && projectEndDate.isAfter(endDate))) {
					endDate = projectEndDate;
				}
			});
		}
		let hasDates = startDate !== null && endDate !== null;
		if (startDate === null) {
			startDate = moment();
		}
		if (endDate === null) {
			endDate = startDate.clone().add(1, 'M');
		}
		return {startDate: startDate, endDate: endDate, hasDates: hasDates};
	}

	handleSelectPerson(option) {
		if (option.isTeam) {
			const callbackPositive = selectedPersons => {
				const onSuccess = () => {
					// CreateProjectPersonMutation currently only returns 1 of the added persons, so to ensure all are loaded, retry the entire page query.
					if (selectedPersons?.length > 1 && this.state.retry) {
						this.state.retry();
					}

					if (this.props.viewer.project ? this.props.viewer.project.useManualAllocations : this.props.viewer.projectGroup.projects.edges[0].node.useManualAllocations) {
						showModal(
							{
								type: MODAL_TYPE.ALLOCATE_TEAM_MEMBERSV2,
								projectId: this.props.viewer.project ? this.props.viewer.project.id : undefined,
								projectGroupId: this.props.viewer.projectGroup ? this.props.viewer.projectGroup.companyProjectGroupId : undefined,
								selectedTeamMembersIds: selectedPersons,
							},
							true
						);
					}
				};
				const mutationObject = {personIds: selectedPersons};
				if (this.props.viewer.project) {
					mutationObject.projectId = this.props.viewer.project.id;
				} else {
					mutationObject.projectGroupId = this.props.viewer.projectGroup.id;
				}
				Util.CommitMutation(CreateProjectPersonMutation, mutationObject, onSuccess);
			};

			const team = this.props.viewer.company.teams.edges.find(team => team.node.id === option.value);
			if (team) {
				const projectPersonIds = this.props.viewer.project
					? this.props.viewer.project.projectPersons.edges.map(pp => pp.node.person.id)
					: this.props.viewer.projectGroup.projects.edges[0].node.projectPersons.edges.map(pp => pp.node.person.id);
				let teams = cloneDeep(this.props.viewer.company.teams.edges).slice();
				teams.forEach(team => {
					team.node.teamPersons.edges = team.node.teamPersons.edges.filter(tp => tp.node.person.active && !projectPersonIds.includes(tp.node.person.id));
				});
				teams = teams.filter(t => t.node.teamPersons.edges.length !== 0);
				showModal({
					type: MODAL_TYPE.ADD_TEAM,
					companyId: this.props.viewer.company.id,
					initialTeam: option.value,
					creatingTeam: false,
					teams: this.nonEmptyTeams,
					projectId: this.props.viewer.project ? this.props.viewer.project.id : null,
					projectGroupId: this.props.viewer.projectGroup ? this.props.viewer.projectGroup.id : null,
					callbackPositive: callbackPositive,
				});
			}
		} else {
			const onSuccess = () => {
				createToast({message: this.props.intl.formatMessage({id: 'settings_team.person-has-been-added'}), duration: 3000});
				if (this.props.viewer.project ? this.props.viewer.project.useManualAllocations : this.props.viewer.projectGroup.projects.edges[0].node.useManualAllocations) {
					showModal(
						{
							type: MODAL_TYPE.ALLOCATE_TEAM_MEMBERSV2,
							projectId: this.props.viewer.project ? this.props.viewer.project.id : undefined,
							projectGroupId: this.props.viewer.projectGroup ? this.props.viewer.projectGroup.companyProjectGroupId : undefined,
							selectedTeamMembersIds: [option.value],
						},
						true
					);
				}
			};
			if (this.props.viewer.project) {
				const person = this.props.viewer.company.allPersons.edges.find(person => person.node.id === option.value);
				if (person) {
					Util.CommitMutation(
						CreateProjectPersonMutation,
						{
							projectId: this.props.viewer.project.id,
							personId: option.value,
							roleId: person.node.role ? person.node.role.id : null,
						},
						onSuccess
					);
				}
			} else {
				const person = this.props.viewer.company.allPersons.edges.find(person => person.node.id === option.value);
				if (person) {
					Util.CommitMutation(
						CreateProjectPersonMutation,
						{
							projectGroupId: this.props.viewer.projectGroup.id,
							personId: option.value,
							roleId: person.node.role ? person.node.role.id : null,
						},
						onSuccess
					);
				}
			}
		}
	}

	getPersonsTeam(projectPerson) {
		const personTeams = [];
		this.props.viewer.company.teams.edges.forEach(team => {
			const teamPersonIds = team.node.teamPersons.edges.map(tp => tp.node.person.id);
			if (teamPersonIds.includes(projectPerson.person.id)) {
				personTeams.push(team.node.name);
			}
		});
		return personTeams;
	}

	handlePersonInputEvent(e) {
		if (e.key === 'Enter') {
			const filterValue = this.state.addPeopleSearchValue;
			let options = [
				{
					options: this.peopleOptions,
				},
				{
					options: this.teamOptions,
				},
			];
			options = options.map(type =>
				type.options.filter(option => {
					return !filterValue.trim() || Util.normalizedIncludes(option.label, filterValue);
				})
			);
			if (options[0].length === 1 && options[1].length === 0) {
				this.handleSelectPerson(options[0][0]);
			}
			if (options[0].length === 0 && options[1].length === 1) {
				this.handleSelectPerson(options[1][0]);
			}
		} else {
			this.setState({addPeopleSearchValue: e.target.value});
		}
	}

	exportToTeams() {
		this.setState({exportingTeam: true});
		const teamName = `${this.props.viewer.project.companyProjectId} - ${this.props.viewer.project.name}`;

		Util.CommitMutation(ExportTeamToTeamsMutation, {projectId: this.props.viewer.project.id, teamName: teamName}, res => {
			this.setState({exportingTeam: false});

			// Create toast
			createToast({message: this.props.intl.formatMessage({id: res.exportTeamToTeams.project.teamsId ? 'project_team.export_to_teams_success' : 'project_team.export_to_teams_failed'}), duration: 3000});

			if (res.exportTeamToTeams.project.teamsId) {
				this.setState({msTeamsTeams: [...this.state.msTeamsTeams, {value: res.exportTeamToTeams.project.teamsId, label: teamName}]});
			}
		});
	}

	linkToTeams(team) {
		this.setState({exportingTeam: true});
		Util.CommitMutation(LinkTeamToTeamsMutation, {projectId: this.props.viewer.project.id, teamId: team.value}, res => {
			this.setState({exportingTeam: false});

			// Create toast
			createToast({message: this.props.intl.formatMessage({id: res.linkTeamToTeams.project.teamsId ? 'project_team.link_to_teams_success' : 'project_team.link_to_teams_failed'}), duration: 3000});
		});
	}

	unlinkTeams() {
		Util.CommitMutation(UnlinkTeamsMutation, {projectId: this.props.viewer.project.id});
	}

	getTeams() {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		const init = {headers: headers, credentials: 'include'};

		fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'msteams/teams', init)
			.then(result => result.json())
			.then(teams => {
				this.setState({
					msTeamsTeams: teams.map(t => ({value: t.id, label: t.displayName})),
				});
			});
	}

	getTeamLink() {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');
		const init = {headers: headers, credentials: 'include'};

		fetch(process.env.GRAPHQL_ENDPOINT.slice(0, -7) + 'msteams/link?teamId=' + this.props.viewer.project.teamsId, init)
			.then(result => result.json())
			.then(link => window.open(link.message));
	}

	getHeaderTitle() {
		return (
			<TopHeaderBarWrapper>
				<TopHeaderBar title={this.props.intl.formatMessage({id: 'common.team'})} content={[]} />
			</TopHeaderBarWrapper>
		);
	}

	getHeader(isInGroup, projectLocked, personSelectorPeople, startingDate) {
		const {formatMessage} = this.props.intl;
		const rightContent = [],
			leftContent = [];
		if (this.props.viewer.project && (this.props.viewer.project.status === PROJECT_STATUS.DONE || this.props.viewer.project.status === PROJECT_STATUS.HALTED)) {
			const indicator = {
				type: ELEMENT_TYPE.INDICATOR,
				status: this.props.viewer.project.status,
			};
			leftContent.push(indicator);
		}
		rightContent.push({
			type: ELEMENT_TYPE.SEARCH,
			value: this.state.searchFilterValue,
			onChange: this.handleSearchChange.bind(this),
		});
		if (hasPermission(PERMISSION_TYPE.PROJECT_PERSON_CREATE) && !isInGroup && !projectLocked) {
			rightContent.push({
				type: ELEMENT_TYPE.NESTED_DROPDOWN,
				options: personSelectorPeople,
				value: this.state.selectedPersonName,
				callback: this.handleSelectPerson.bind(this),
				placeholder: formatMessage({id: 'person_selector.placeholder'}),
				cy: 'add-people-to-project',
			});
		}

		if (this.props.viewer.company.teamsEnabled && this.props.viewer.project) {
			if (this.props.viewer.project.teamsId) {
				leftContent.push(
					<Button onClick={() => this.unlinkTeams()} iconPosition={'last'} icon={() => <MSTeamsIcon />} variant={Button.VARIANT.PURPLE_FILLED} size={Button.SIZE.STANDARD} showText={true}>
						{formatMessage({id: 'common.unlink'})}
					</Button>
				);

				const connectedTeam = this.state.msTeamsTeams.find(team => team.value === this.props.viewer.project.teamsId);

				leftContent.push(<span className="teams-text-label">{'Linked to: ' + (connectedTeam ? connectedTeam.label : 'unknown')}</span>);
				if (connectedTeam) {
					leftContent.push(
						<Button onClick={() => this.getTeamLink()} iconPosition={'last'} icon={() => <MSTeamsIcon />} variant={Button.VARIANT.VERY_LIGHT_GRAY_OUTLINE} size={Button.SIZE.STANDARD}>
							{formatMessage({id: 'project_team.go_to'})}
						</Button>
					);
				}
			} else {
				leftContent.push(
					<Button onClick={() => this.exportToTeams()} iconPosition={'last'} icon={() => <MSTeamsIcon />} variant={Button.VARIANT.PURPLE_FILLED} size={Button.SIZE.STANDARD} showText={true} disabled={!!this.state.exportingTeam}>
						{formatMessage({id: 'project_team.export_to_teams'})}
					</Button>
				);
				leftContent.push({
					type: ELEMENT_TYPE.DROPDOWN,
					dropdownOptions: this.state.msTeamsTeams,
					value: null,
					callback: this.linkToTeams.bind(this),
					placeholder: formatMessage({id: 'project_team.link_to_teams'}),
					disabled: !!this.state.exportingTeam,
				});
			}
		}

		if (hasFeatureFlag('third_level_nav', this.props.viewer.availableFeatureFlags)) {
			return buildThirdLevelNavHeader(leftContent, rightContent);
		}

		return <HeaderBar innerRef={div => (this.header_bar = div)} parentGroup={null} leftContent={leftContent} rightContent={rightContent} />;
	}

	render() {
		const {formatMessage} = this.props.intl;
		const projectLocked = this.props.viewer.project !== undefined && this.props.viewer.project !== null && (this.props.viewer.project.status === 'DONE' || this.props.viewer.project.status === 'HALTED');
		const isInGroup = this.props.viewer.project && this.props.viewer.project.isInProjectGroup;
		const useNewPermissions = hasFeatureFlag('permission_management', this.props.viewer.availableFeatureFlags);
		const isAdmin = hasPermission(PERMISSION_TYPE.MANAGE_ACCOUNT_SETTINGS);
		const useTimeApproval = usingTimeApproval(this.props.viewer.company);
		const hasProjectPersonUpdateAccess = hasPermission(PERMISSION_TYPE.PROJECT_PERSON_UPDATE);

		let projectPeople = [];
		projectPeople = this.props.viewer.project ? this.props.viewer.project.projectPersons.edges.map(p => p.node) : this.props.viewer.projectGroup.projects.edges[0].node.projectPersons.edges.map(p => p.node);
		const projectGroupProjectPersonsMap = new Map(),
			projectPersonProjectMap = new Map();
		if (this.props.viewer.projectGroup) {
			this.props.viewer.projectGroup.projects.edges.forEach(project => {
				project.node.projectPersons.edges.forEach(pp => {
					projectPersonProjectMap.set(pp.node.id, project.node);
					const key = pp.node.person.id;
					const projectPersonsList = projectGroupProjectPersonsMap.has(key) ? projectGroupProjectPersonsMap.get(key) : [];
					projectPersonsList.push(pp);
					projectGroupProjectPersonsMap.set(key, projectPersonsList);
				});
			});
		}

		const personSelectorPeople = [
			{
				cy: 'team-members-option',
				label: formatMessage({id: 'settings.team-members'}),
				emptyText: formatMessage({id: 'people_selector.team_persons_option_empty_msg'}),
				options: this.peopleOptions,
				nestedOptions: this.peopleOptions,
			},
			{
				cy: 'your-teams',
				label: formatMessage({id: 'people_selector.team_option_title'}),
				emptyText: formatMessage({id: 'people_selector.team_option_empty_msg'}),
				options: this.teamOptions,
				nestedOptions: this.teamOptions,
			},
		];

		if (this.state.searchFilterValue.length > 0) {
			const searchFilter = projectPerson => {
				const taskValue = projectPerson.person.firstName + projectPerson.person.lastName + projectPerson.person.email + (projectPerson.role ? projectPerson.role.name : '') + (projectPerson.person.role ? projectPerson.person.role.name : '');
				const searchValue = this.state.searchFilterValue.trim();
				return Util.normalizedIncludes(taskValue, searchValue);
			};
			projectPeople = projectPeople.filter(searchFilter);
		}
		let startingDate = null;
		if (this.props.viewer.project && this.props.viewer.project.projectStartYear && this.props.viewer.project.projectStartMonth && this.props.viewer.project.projectStartDay)
			// Is project and has start
			startingDate = Util.CreateNonUtcMomentDate(this.props.viewer.project.projectStartYear, this.props.viewer.project.projectStartMonth, this.props.viewer.project.projectStartDay);
		let useManualAllocations;
		if (this.props.viewer.project && this.props.viewer.project.useManualAllocations) {
			useManualAllocations = true;
		} else if (this.props.viewer.projectGroup && this.props.viewer.projectGroup.useManualAllocations) {
			useManualAllocations = true;
		}
		return (
			<div className="section-content project-team">
				{this.props.children}
				{this.getHeader(isInGroup, projectLocked, personSelectorPeople, startingDate)}
				<>
					<div className="section-body">
						{projectPeople.length ? (
							<div className="member-table">
								<table>
									<thead>
										<tr>
											<th className="column-person">{formatMessage({id: 'settings_team.person'})}</th>
											<th className="column-role">{formatMessage({id: 'settings_team.main-role'})}</th>
											<th className="column-role">{formatMessage({id: 'settings_team.project-role'})}</th>
											<th className="column-permissions">{formatMessage({id: 'common.permission'})}</th>
											<th className="column-contact-person">
												<div className="header-container">
													<span className="header-text">{formatMessage({id: 'common.project_owner'})}</span>
													<ForecastTooltip content={formatMessage({id: useTimeApproval ? 'project_team.owner_tooltip' : 'project_team.tooltip'})}>
														<InformationIcon />
													</ForecastTooltip>
												</div>
											</th>
											<th className="column-teams">{formatMessage({id: 'common.team'})}</th>
											{this.props.viewer.company.harvestEnabled ? <th className="column-controls">{formatMessage({id: 'title.app_harvest'})}</th> : null}
											<th className="column-controls">&nbsp;</th>
										</tr>
									</thead>
									<tbody>
										{projectPeople.map(projectPerson => (
											<ProjectTeamLineItem
												key={projectPerson.id}
												roles={this.props.viewer.company.roles.edges}
												projectPerson={projectPerson}
												company={this.props.viewer.company}
												projectId={this.props.viewer.project ? this.props.viewer.project.id : null}
												projectGroupId={this.props.viewer.projectGroup ? this.props.viewer.projectGroup.id : null}
												useNewPermissions={useNewPermissions}
												profiles={this.props.viewer.company.profiles.edges}
												projectLocked={projectLocked}
												isAdmin={isAdmin}
												isInGroup={isInGroup}
												isClient={isClientUser()}
												hasProjectPersonUpdateAccess={hasProjectPersonUpdateAccess}
												personTeams={this.getPersonsTeam(projectPerson)}
												isProjectGroup={this.props.viewer.projectGroup !== null && this.props.viewer.projectGroup !== undefined}
												projectGroupProjectPersonsMap={projectGroupProjectPersonsMap}
												projectPersonProjectMap={projectPersonProjectMap}
												useManualAllocations={useManualAllocations}
											/>
										))}
									</tbody>
								</table>
							</div>
						) : (
							<GenericEmptyState className="team-empty-state" headerText={formatMessage({id: 'empty_state.project_team.header_text'})} text={formatMessage({id: 'empty_state.project_team.text'})} iconClass="team" />
						)}
					</div>
				</>
			</div>
		);
	}
}

ProjectSettingsTeam.propTypes = {
	projectId: PropTypes.string,
	selectedPersons: PropTypes.arrayOf(PropTypes.object),
	allocation: PropTypes.object,
	retry: PropTypes.func,
};

export default ProjectSettingsTeam;
